import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.error = null;
      
      // Gem token i localStorage
      localStorage.setItem('token', action.payload.token);
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.token = null;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.error = null;
      
      // Fjern fra localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Ryd også game data fra localStorage
      localStorage.removeItem('championsLeagueGame');
      localStorage.removeItem('championsLeagueRealResults');
      localStorage.removeItem('championsLeaguePhaseLocks');
    },
    clearError: (state) => {
      state.error = null;
    },
    // Load authentication state from localStorage on app start
    loadAuthFromStorage: (state) => {
      const token = localStorage.getItem('token');
      
      if (token) {
        state.isAuthenticated = true;
        state.token = token;
      }
    },
    // Action til at opdatere token (f.eks. ved token refresh)
    updateToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  clearError,
  loadAuthFromStorage,
  updateToken,
} = authSlice.actions;

// Selectors til nem adgang til auth data
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;

export default authSlice.reducer;
